import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";

const EV_START = new Date("2026-10-14T00:00:00");
const EV_END = new Date("2026-10-30T00:00:00");
const POLLS_OPEN = new Date("2026-11-03T07:00:00-06:00");
const POLLS_CLOSE = new Date("2026-11-03T19:00:00-06:00");

export const EarlyVoteCountdown = ({ ctaTo }) => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(id);
  }, []);
  if (now >= POLLS_CLOSE) return null;
  let label, target, sub;
  if (now < EV_START) {
    label = "EARLY VOTING BEGINS OCT 14 — IN";
    target = EV_START;
    sub = "Early vote Oct 14–29 · Election Day Nov 3 · Register by Oct 5";
  } else if (now < EV_END) {
    label = "EARLY VOTING IS OPEN — ENDS OCT 29 IN";
    target = EV_END;
    sub = "Vote early through Oct 29 · Election Day is Nov 3";
  } else if (now < POLLS_OPEN) {
    label = "POLLS OPEN TUESDAY, NOV 3 AT 7 AM — IN";
    target = POLLS_OPEN;
    sub = "Early voting has ended — make a plan to vote on Election Day";
  } else {
    label = "POLLS CLOSE AT 7 PM — YOU HAVE";
    target = POLLS_CLOSE;
    sub = "If you are in line at 7 PM, stay in line — they must let you vote";
  }
  const ms = Math.max(0, target - now);
  const days = Math.floor(ms / 86400000);
  const hrs = Math.floor((ms % 86400000) / 3600000);
  const mins = Math.floor((ms % 3600000) / 60000);
  return (
    <div className="bg-slate-900 border-2 border-amber-500 rounded-2xl p-5 md:p-6 mb-8 max-w-4xl mx-auto text-center shadow-xl" data-testid="fol-early-vote-countdown">
      <p className="text-amber-400 text-xs md:text-sm font-black tracking-[0.2em] uppercase mb-4 inline-flex items-center gap-2">
        <Clock className="w-4 h-4" /> {label}
      </p>
      <div className="flex justify-center gap-3 md:gap-5">
        {[{ v: days, l: "DAYS" }, { v: hrs, l: "HOURS" }, { v: mins, l: "MINUTES" }].map((u) => (
          <div key={u.l} className="bg-slate-800 border border-amber-500/40 rounded-xl px-5 py-3 min-w-[86px]" data-testid={`fol-countdown-${u.l.toLowerCase()}`}>
            <p className="text-3xl md:text-4xl font-black text-white tabular-nums">{u.v}</p>
            <p className="text-[10px] font-black tracking-widest text-amber-400 mt-1">{u.l}</p>
          </div>
        ))}
      </div>
      <p className="text-slate-400 text-xs mt-4 font-semibold">{sub}</p>
      {ctaTo && (
        <Link to={ctaTo} className="inline-flex items-center gap-1.5 mt-3 text-amber-300 text-sm font-black hover:text-amber-200 transition-colors" data-testid="countdown-slate-link">
          See the Labor Slate — every endorsed candidate <ArrowRight className="w-4 h-4" />
        </Link>
      )}
    </div>
  );
};
